export default {
  backToTop: 'Retour en haut de page',
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/footer.js